import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/offersSlice";

import offersApis from "src/api/offers";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

const CoupanListDeatilsSaga = function* CoupanListDeatilsSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  console.log("payload", payload);

  try {
    const response: common.ResponseGenerator = yield call(
      offersApis.coupanlist,
      payload
    );

    if (response?.code === "-1") {
      throw new Error("Session Expire");
    } else if (response?.code === "0") {
      throw new Error(response?.message);
    }
    yield put(actions.coupanListDetailsSuccess(response));
    resolve(response);
  } catch (error) {
    yield put(
      actions.coupanListDetailsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

const CheckDiscountSaga = function* CheckDiscountSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  console.log("payload", payload);

  try {
    const response: common.ResponseGenerator = yield call(
      offersApis.checkDiscount,
      payload
    );

    if (response?.code === "-1") {
      throw new Error("Session Expire");
    } else if (response?.code === "0" || response?.code === 0) {
      throw new Error(response?.message);
    }
    yield put(actions.checkDiscountSuccess(response));
    resolve(response);
  } catch (error) {
    yield put(
      actions.checkDiscountError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

export default function* offersSaga() {
  yield all([
    takeEvery(actions.coupanListDetailsRequest, CoupanListDeatilsSaga),
    takeEvery(actions.checkDiscountRequest, CheckDiscountSaga),
  ]);
}
